<template>
	<div style="background-color: #c3e2fa;">
		<Header></Header>
		<router-view style="min-height:55.5vh;width: 1200px;margin: 0 auto;"/>
		<Footer></Footer> 
		
	</div>
	
</template>

<script>
	// import index from './components/Index.vue'

export default {
  name: 'app',
  components: {
	  // index
  }
}
</script>

<style>
	body{
		margin: 0;
		padding: 0;
		min-width: 1200px;
	}
	* {
		margin: 0;
		padding: 0;
	}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
